import React from 'react';
import PropTypes from 'prop-types';
import Aux from '../../../common/helpers/AuxWrapper';
import { SwitchOption } from './Option.styled';

export const Option = props => {
  let { onClick, selected, ariaRole, ariaLabel, tabIndex, ariaDisable } = props;
  return (
    <Aux>
      <SwitchOption
        role={ariaRole}
        ariaLabel={ariaLabel}
        ariaChecked={selected}
        onClick={onClick}
        selected={selected}
        tabIndex={tabIndex}
        ariaDisable={ariaDisable}
      />
    </Aux>
  );
};

Option.propTypes = {
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  ariaRole: PropTypes.string,
  ariaLabel: PropTypes.string,
  tabIndex: PropTypes.string,
  ariaDisable: PropTypes.bool
};

export default Option;
